import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { MDCTextField } from '@material/textfield';

/*import "~@material/textfield/mdc-text-field.scss";*/
import './YantraPage.css';

function YInput(props) {
  return (
     <div className="bdate-group">
      <div className="mdc-text-field input-group group1 row">
          <input type="number" id="dayTextField" className="mdc-text-field__input yinput" maxLength={2} key={1}
                 aria-label="Day of birth"
                 autoComplete="off" onChange={props.onChange}/>
          <label className="mdc-floating-label" htmlFor="dayTextField">Day of birth</label>
          <div className="mdc-line-ripple"></div>
      </div>

      <div className="mdc-text-field input-group group2 row">
          <input type="number" id="monthTextField" className="mdc-text-field__input yinput" maxLength={2} key={2}
                 aria-label="Month of birth"
                 autoComplete="off" onChange={props.onChange}/>
          <label className="mdc-floating-label" htmlFor="monthTextField">Month of birth</label>
          <div className="mdc-line-ripple"></div>
      </div>

      <div className="mdc-text-field input-group group3 row">
          <input type="number" id="yearTextField" className="mdc-text-field__input yinput" maxLength={4} key={3}
                 aria-label="Year of birth"
                 autoComplete="off" onChange={props.onChange}/>
          <label className="mdc-floating-label" htmlFor="yearTextField">Year of birth</label>
          <div className="mdc-line-ripple"></div>
      </div>
     </div>

    /*<div className="input-group row">
          {yinput}
    </div>*/
    );
}

class YantraForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yantraResult: '',
      key: '',
      value: '',
      title: '',
      pathRedirect : "",
      redirect: false,
      textField1: '',
      textField2: '',
      textField3: ''
    };

    this.handleChange = this.handleChange.bind(this);
  }
  
  componentDidMount() {
    const textField1 = new MDCTextField(document.querySelector('.group1'));
    const textField2 = new MDCTextField(document.querySelector('.group2'));
    const textField3 = new MDCTextField(document.querySelector('.group3'));

    /*const currentDate = new Date();

    textField1.value = currentDate.getDate();
    textField2.value = currentDate.getMonth() + 1;
    textField3.value = currentDate.getFullYear();*/

    this.setState({textField1: textField1, textField2: textField2, textField3: textField3});

    this.loadFbLoginApi();
    localStorage.removeItem('fb_purchase_token');
    localStorage.removeItem('bt_nonce');
      // Only fall back to re-deriving a session from the social provider
      // token when there is no active app session yet. Previously this ran
      // unconditionally on every visit to this page, re-validating
      // fb_access_token/google_access_token even when y_jwt_token was still
      // perfectly valid (proven by other pages, e.g. Saved Yantras, working
      // fine with it). Facebook/Google access tokens are short-lived and
      // routinely expire long before the app's own JWT session does, so
      // that re-validation would fail on a stale-but-harmless social token
      // and log the user out of an otherwise valid session — which is what
      // made "Reveal My Yantra" appear to silently do nothing.
      if (!localStorage.getItem("y_jwt_token")) {
          if (localStorage.getItem("fb_access_token")) {
              this.facebookLogin(localStorage.getItem("fb_access_token"));
          } else if (localStorage.getItem("google_access_token")) {
              this.googleLogin(localStorage.getItem("google_access_token"));
          } else {
              this.setState({pathRedirect: "/", redirect: true});
          }
      }
    /*var fb_purchase_token = localStorage.getItem('fb_purchase_token');
    if(fb_purchase_token) {
      window.FB.api(
          '/' + fb_purchase_token + '/consume',    // Replace the PURCHASE_TOKEN
          'post',
          {access_token: localStorage.getItem('fb_access_token')},         // Replace with a user access token
          result => {
              console.log('Result:', result);
              localStorage.removeItem('fb_purchase_token');
              localStorage.removeItem('google_access_token');
          }
      );
    }*/
      /*window.google.accounts.id.initialize({
          client_id: "189879900990-j48su5nkn32vslbc57fssmkmtsqjt7s3.apps.googleusercontent.com",
      });*/
  }

    facebookLogin = (token) => {
        fetch(process.env.REACT_APP_API_BASE_URL + '/authentication/login/facebook/code/' + token,
            {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }})
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.data && result.data.message && result.data.message === 'Invalid OAuth access token.') {
                        localStorage.removeItem('fb_access_token');
                        localStorage.removeItem('y_jwt_token');
                        this.setState({pathRedirect : "/", redirect: true})
                    } else if(result.status !== undefined) {
                        localStorage.removeItem('fb_access_token');
                        localStorage.removeItem('y_jwt_token');
                        this.setState({pathRedirect : "/", redirect: true})
                    } else {
                        localStorage.removeItem('google_access_token');
                        localStorage.setItem('fb_access_token', token);
                        localStorage.setItem('y_jwt_token', result.jwtToken);
                    }
                },
                (error) => {
                    localStorage.removeItem('fb_access_token');
                    console.log("error", error)
                    this.googleLogout();
                    localStorage.removeItem('y_jwt_token');
                    this.setState({ pathRedirect : "/", redirect: true})
                }
            )
    }

    googleLogin = (token) => {
        fetch(process.env.REACT_APP_API_BASE_URL + '/authentication/login/google/code/' + token,
            {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }})
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.data && result.data.message) {
                        this.googleLogout();
                        localStorage.removeItem('google_access_token');
                        localStorage.removeItem('y_jwt_token');
                        this.setState({pathRedirect : "/", redirect: true})
                    } else if(result.status !== undefined) {
                        this.googleLogout();
                        localStorage.removeItem('google_access_token');
                        localStorage.removeItem('y_jwt_token');
                        this.setState({pathRedirect : "/", redirect: true})
                    } else {
                        localStorage.removeItem('fb_access_token');
                        localStorage.setItem('google_access_token', token);
                        localStorage.setItem('y_jwt_token', result.jwtToken);
                    }
                },
                (error) => {
                    console.log("error", error)
                    this.googleLogout();
                    localStorage.removeItem('google_access_token');
                    localStorage.removeItem('y_jwt_token');
                    this.setState({pathRedirect : "/", redirect: true})
                }
            )
    }

  scrollToBottom = () => {
      document.querySelector(".yform").scrollIntoView({ behavior: 'auto' });
  }

  hideBraintreePayment = () => {
      document.querySelector('.ytitle').style.display = 'block';
      document.querySelector('.bdate-group').style.display = 'block';
      document.querySelector('#uncover-yantra').textContent = 'UNCOVER MY YANTRA €8.99';
      document.querySelector('#dropin-container').textContent = '';
      document.querySelector('#close-payment').style.display = 'none';
      document.querySelector('#payment_refused').style.display = 'none';
      document.querySelector('.navbar').style.display = 'block';

      document.querySelector('#droppin-container').hidden = true;
      document.querySelector('#uncover-yantra').style.display = 'block'
  }

  hidePaypal = () => {
      document.querySelector('.ytitle').style.display = 'block';
      document.querySelector('.bdate-group').style.display = 'block';
      document.querySelector('#uncover-yantra').style.display = 'block'
      document.querySelector('#close-payment').style.display = 'none';
      document.querySelector('#payment_refused').style.display = 'none';
      document.querySelector('.navbar').style.display = 'block';
      /*document.querySelector('#droppin-container').hidden = true;*/

      document.querySelector('#paypal-button-container').textContent = '';
  }

  paypalLoad() {
      /*document.querySelector('#droppin-container').hidden = false;*/
      document.querySelector('.ytitle').style.display = 'none';
      document.querySelector('.bdate-group').style.display = 'none';
      document.querySelector('.navbar').style.display = 'none';
      document.querySelector('#uncover-yantra').style.display = 'none'
      document.querySelector('#close-payment').style.display = 'block';

      var self = this;
      window.paypal.Buttons({
          createOrder: function(data, actions) {
              // This function sets up the details of the transaction, including the amount and line item details.
              return actions.order.create({
                  purchase_units: [{
                      custom_id: self.state.yantraResult.boughtYantra.id,
                      amount: {
                          value: '8.99'
                      }
                  }]
              });
          },
          onApprove: function(data, actions) {
              return actions.order.capture().then(function(details) {
                  // alert('Transaction completed by ' + details.payer.name.given_name);
                  var url  = process.env.REACT_APP_API_BASE_URL + '/paypal/prod/transaction-complete/' + data.orderID;
                  // Call your server to save the transaction
                  return fetch(url, {
                      method: 'post',
                      headers: {
                          'Authorization' : localStorage.getItem('y_jwt_token')
                      }/*,
                      body: JSON.stringify({
                          orderID: data.orderID
                      })*/
                  }).then(response => response.text())
                      .then( (response) => {
                          if(response.message) {
                              if(response.status !== 200) {
                                  localStorage.removeItem('fb_access_token');
                                  localStorage.removeItem('google_access_token');
                                  self.googleLogout();
                                  localStorage.removeItem('y_jwt_token');
                                  self.setState({yantraResult : response, pathRedirect : "/", redirect: true});
                              }
                          } else {
                              if(response){
                                  if(response === 'false') {
                                      document.querySelector('#payment_refused').style.display = 'block';
                                      localStorage.removeItem('bt_nonce');
                                      self.setState({yantraResult: '', pathRedirect : "/yantra", redirect: false});
                                  } else {
                                      setTimeout(self.getYantra(), 1000);
                                  }
                              } else {
                                  self.setState({yantraResult: '', pathRedirect : "/yantra", redirect: false});
                              }
                          }
                      });
              });
          }
      }).render('#paypal-button-container');
  }

  brantreeLoad() {
      var self = this;
      var url  = process.env.REACT_APP_API_BASE_URL + '/braintree/sandbox-client-token';
      fetch(url, {
          method: "get",
          headers: {
              // 'Accept': 'application/json',
              // 'Content-Type': 'application/json',
              'Authorization' : localStorage.getItem('y_jwt_token')
          }
      })
          .then(response => response.text())
          .then( (response) => {
                  if(response){
                      document.querySelector('.ytitle').style.display = 'none';
                      document.querySelector('.bdate-group').style.display = 'none';
                      document.querySelector('.navbar').style.display = 'none';
                      document.querySelector('#uncover-yantra').textContent = 'PAY €8.99';
                      var button = document.querySelector('#uncover-yantra');
                      window.braintree.dropin.create({
                          authorization: response,
                          container: '#dropin-container',
                          vaultManager: true,
                          card: {
                              cardholderName: {
                                  required: true
                              }
                          }
                      }, function (createErr, instance) {
                          document.querySelector('#close-payment').style.display = 'block';
                          self.scrollToBottom();
                          button.addEventListener('click', function () {
                              instance.requestPaymentMethod(function (err, payload) {
                                  // Submit payload.nonce to your server
                                  localStorage.setItem('bt_nonce', payload.nonce);
                                  var url  = process.env.REACT_APP_API_BASE_URL + '/braintree/sandbox/checkout/' + payload.nonce;
                                  fetch(url, {
                                      method: "post",
                                      headers: {
                                          // 'Accept': 'application/json',
                                          // 'Content-Type': 'application/json',
                                          'Authorization' : localStorage.getItem('y_jwt_token')
                                      }
                                  })
                                      .then(response => response.text())
                                      .then( (response) => {
                                          if(response.message) {
                                              if(response.status !== 200) {
                                                  localStorage.removeItem('fb_access_token');
                                                  localStorage.removeItem('google_access_token');
                                                  self.googleLogout();
                                                  localStorage.removeItem('y_jwt_token');
                                                  self.setState({yantraResult : response, pathRedirect : "/", redirect: true});
                                              }
                                          } else {
                                              if(response){
                                                  if(response === 'false') {
                                                      document.querySelector('#payment_refused').style.display = 'block';
                                                      localStorage.removeItem('bt_nonce');
                                                      self.setState({yantraResult: '', pathRedirect : "/yantra", redirect: false});
                                                  } else {
                                                      setTimeout(self.getYantra(), 1000);
                                                  }
                                              } else {
                                                  self.setState({yantraResult: '', pathRedirect : "/yantra", redirect: false});
                                              }
                                          }
                                      });
                              });
                          });
                      });
                  } else {
                      this.setState({yantraResult: '', pathRedirect : "/yantra", redirect: false});
                  }
              //do something awesome that makes the world a better place
          });
  }

  loadFbLoginApi() {
    window.fbAsyncInit = function() {
        window.FB.init({
            appId      : 548346835996683,
            cookie     : true,  // enable cookies to allow the server to access
            // the session
            xfbml      : true,  // parse social plugins on this page
            version    : 'v5.0' // use version 2.1
        });
        window.FB.AppEvents.logPageView();
    };
      // Load the SDK asynchronously
      (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
  }

  callPayment = () => {
    // var jwt_token = localStorage.getItem('y_jwt_token')
    // var fb_access_token = localStorage.getItem('fb_access_token')
    var obj = {
        method: 'pay',
        // action: 'purchaseiap',
        action: 'purchaseitem',
        // display: 'touch',
        // display: 'popup',
        display: 'iframe',
        product: 'https://yantra.world/product.html',
        // product_id: 'yatra.reveal'
        quantity: 1
    };
    var self = this
    window.FB.ui(obj, function(data) {
        if(data.payment_id) {
            localStorage.setItem('fb_purchase_token', data.payment_id)
            setTimeout(self.getYantra(), 1000);
            /*window.FB.api(
                '/' + data.purchase_token + '/consume',    // Replace the PURCHASE_TOKEN
                'post',
                {access_token: fb_access_token},         // Replace with a user access token
                result => {
                    console.log('consuming product', 'yatra.reveal', 'with purchase token', data.purchase_token);
                    console.log('Result:', result);
                    setTimeout(self.getYantra(), 1000);
                }
            );*/
        } else {
            self.setState({yantraResult: '', pathRedirect: '/yantra', redirect: false});
            /*self.setState({yantraResult: '', pathRedirect: '/', redirect: true});*/
        }
    });
  }

  getYantra = () => {
    var jwt_token = localStorage.getItem('y_jwt_token')
    var url  = process.env.REACT_APP_API_BASE_URL + '/yantra/calculate/day/' + this.state.textField1.value + '/month/' + this.state.textField2.value + '/year/' + this.state.textField3.value;
    fetch(url, {
      method: "get",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization' : jwt_token
      }
    })
    .then(response => response.json())
    .then( (response) => { 
        if(response.message) {
            if(response.message === 'Payment required') {
                if(localStorage.getItem('fb_purchase_token') || localStorage.getItem('bt_nonce')) {
                    setTimeout(this.getYantra(), 1000);
                } else {
                    // this.callPayment();
                    // this.brantreeLoad();
                    this.paypalLoad();
                }
            } else if (response.message.substring(0, 13) === 'Invalid date:') {
                // alert(response.message);
                document.querySelector('#invalid_date').style.display = 'block';
                document.querySelector('#invalid_date').innerHTML = '* ' + response.message;
            } else if(response.status !== 200) {
                localStorage.removeItem('fb_access_token');
                this.googleLogout();
                localStorage.removeItem('google_access_token');
                localStorage.removeItem('y_jwt_token');
                this.setState({yantraResult : response, pathRedirect : "/", redirect: true});
            }
        } else {
            if(response){
                localStorage.removeItem('fb_purchase_token');
                localStorage.removeItem('bt_nonce');
                this.setState({yantraResult : response, pathRedirect : "/details", redirect: true});
            } else {
                this.setState({yantraResult: '', pathRedirect : "/yantra", redirect: false});
            }
        }
      //do something awesome that makes the world a better place
    });
  }

    googleLogout = () => {
        if (localStorage.getItem('google_access_token')) {
            window.google.accounts.id.disableAutoSelect();
            localStorage.removeItem('google_access_token');
            /*window.gapi.auth.authorize(
                {
                    'client_id': '189879900990-j48su5nkn32vslbc57fssmkmtsqjt7s3.apps.googleusercontent.com',
                    'scope': 'profile email',
                    'immediate': false,
                    cookie_policy: 'single_host_origin',
                    response_type: localStorage.getItem('google_access_token')
                },
                function (authResult) {
                    window.gapi.auth.signOut();
                    // localStorage.removeItem('google_access_token');
                }
            );*/
        }
    }

  handleChange(event) {
      document.querySelector('#invalid_date').style.display = 'hidden';
    const textField1 = new MDCTextField(document.querySelector('.group1'));
    const textField2 = new MDCTextField(document.querySelector('.group2'));
    const textField3 = new MDCTextField(document.querySelector('.group3'));
    this.setState({textField1: textField1, textField2: textField2, textField3: textField3})

    const { value, maxLength } = event.target;
    const message = value.slice(0, maxLength);
    event.target.value = message;
  }

  setRedirect = () => {
    this.setState({redirect:true});
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={{
        pathname: this.state.pathRedirect,
        state: { data: this.state.yantraResult,
                  day: this.state.s_day,
                  month: this.state.s_month,
                  year: this.state.s_year
                 },
    }} />
    }
  }



  render() {
    const enabled = this.state.textField1.value !== '' && this.state.textField2.value !== '' && this.state.textField3.value !== '';
    return ( 
            <div className="yform">
                <div id="close-payment">
                    <img src="/img/menubtn2.png" alt="Close payment" onClick={this.hidePaypal}/>
                </div>
                <div className="ytitle">
                    <p>Reveal my Yantra</p>
                </div>
                <div id="dropin-container"></div>
                <div id="payment_refused">* Payment refused</div>
                <div id="invalid_date">* Invalid date</div>

                <div id="paypal-button-container"></div>

                {this.renderRedirect()}
                <YInput inputlist={this.state.inputlist} onChange={this.handleChange}/>
                <div className='btn-group'>
                    <button id='uncover-yantra' className='submit-btn yantra' type='submit' disabled={!enabled} onClick={this.getYantra}>UNCOVER MY YANTRA €8.99</button>{/*€*/}
                </div>
                <div id="fb-root"></div>
            </div>
    )
  }
}

export default YantraForm;



// WEBPACK FOOTER //
// ./src/components/YantraPage/YantraForm.js